import {
  CHAMAMENTO_CLOSES_AT,
  formatShortDate,
  getChamamentoStatus,
  type ChamamentoWindow,
} from "@/lib/competitionApplication";

export interface NavItem {
  label: string;
  href: string;
  /** Destaca o item (cor da marca) enquanto ele é uma chamada temporária. */
  highlight?: boolean;
  /** Texto curto de apoio, usado no menu do celular. */
  hint?: string;
}

const HOME: NavItem = { label: "Home", href: "/" };

const BASE_ITEMS: NavItem[] = [
  { label: "A Federação", href: "/federacao" },
  { label: "Rankings", href: "/rankings" },
  { label: "Eventos", href: "/eventos" },
  { label: "Boxes", href: "/boxes" },
  { label: "Filiação", href: "/filiacao" },
  { label: "Notícias", href: "/noticias" },
  { label: "Atleta Federado", href: "/dashboard/atleta" },
];

const chamamentoItem = (): NavItem => ({
  label: "Chamamento 2027",
  href: "/chamamento-2027",
  highlight: true,
  hint: `até ${formatShortDate(CHAMAMENTO_CLOSES_AT)}`,
});

const isActive = (window: ChamamentoWindow) => window !== "closed";

/** Computador: o menu já está cheio e a logo leva à Home, então o chamamento ocupa o lugar do item "Home" enquanto durar. */
export function getDesktopNavItems(window: ChamamentoWindow = getChamamentoStatus().window): NavItem[] {
  return isActive(window) ? [chamamentoItem(), ...BASE_ITEMS] : [HOME, ...BASE_ITEMS];
}

/** Celular: há espaço, então o chamamento entra no topo e a Home continua no menu. */
export function getMobileNavItems(window: ChamamentoWindow = getChamamentoStatus().window): NavItem[] {
  return isActive(window) ? [chamamentoItem(), HOME, ...BASE_ITEMS] : [HOME, ...BASE_ITEMS];
}
